// import

import cx from 'clsx';
import {styled} from 'goober';
import type {ComponentProps} from 'react';

import type {PostNode, SeriesNode} from 'libs/model';
import {Link} from 'modules/Link';
import {Type} from 'modules/Type';

// types

type Props = ComponentProps<typeof Styled> & {
  post: PostNode;
  series: SeriesNode;
};

// component

export function PostSeries(props: Props) {
  const {series, post, ...rest} = props;

  return series.meta.postRefs?.length ? (
    <Styled {...rest}>
      <div className="subhead">More from this series...</div>
      <header>{series.meta.title}</header>

      <Type>
        <div
          className="body"
          dangerouslySetInnerHTML={{__html: series.meta.blurbMark}}
        />

        <ol className="posts">
          {series.meta.postRefs.map((p) => (
            <li key={p.meta.id} className="post">
              <Link
                className={cx('red', {
                  current: post.meta.id === p.meta.id,
                })}
                href={p.meta.link}
              >
                {p.meta.title}
              </Link>
            </li>
          ))}
        </ol>
      </Type>
    </Styled>
  ) : null;
}

// styles

const Styled = styled('nav')`
  header {
    margin-bottom: 0.5rem;
    font-family: var(--font-head);
    font-size: 2rem;
    font-weight: 500;
    letter-spacing: normal;
  }

  .subhead {
    text-transform: uppercase;
    font-size: 1rem;
    letter-spacing: normal;
  }

  .current {
    font-weight: 500;
  }
`;
